

module.exports = __webpack_require__.stylable.create(
    "SampleLayout3406788895",
    {"classes":{"root":"SampleLayout3406788895__root","group":"SampleLayout3406788895__group","groupItems":"SampleLayout3406788895__groupItems"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    5,
    "SampleLayout3406788895",
    null
);
